import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
import { type FunctionComponent } from 'react';

import { HEADER_IMAGES_MAP } from '../../assets';

export type Product =
	| 'Confluence'
	| 'Jira Service Management'
	| 'Jira Product Discovery'
	| 'Rovo Team 25'
	| 'Multi Product Upgrades'
	| 'Rovo Dev Adoption';

type HeaderImageProps = {
	image?: Product;
};

export const HeaderImage: FunctionComponent<HeaderImageProps> = ({ image = 'Confluence' }) => {
	const { colorMode } = useThemeObserver();

	const HeaderImageLight = HEADER_IMAGES_MAP[image]['light'];
	const HeaderImageDark = HEADER_IMAGES_MAP[image]['dark'];

	return colorMode === 'dark' ? <HeaderImageDark /> : <HeaderImageLight />;
};
